<template>
  <v-card class="px-5 overflow-hidden" height="90vh">
    <!-- title -->
    <v-card-title class="mb-2">
      <span class="primary--text">Assign Case</span>
      <v-icon
        v-if="showCloseBtn"
        class="ml-auto"
        @click="$emit('close')"
      >
        mdi-close
      </v-icon>
    </v-card-title>

    <v-card-subtitle class="black--text">
      <div class="font-weight-bold">{{ full_name || 'N&frasl;A' }}</div>
      <div>Case Title: {{ info.health_concern }}</div>
      <div>Case No: {{ info.case_number }}</div>
      <div>Schedule: {{ schedule }}</div>
      <!-- <v-btn @click="getInfo()">getInfo</v-btn> -->
    </v-card-subtitle>

    <v-card-text style="height: 400px;">
      <doctors-table
        v-model="doctors"
        @newcase="consolelog"
        show-assign-column
        :info="info"
        @assigned="$emit('close')"
      ></doctors-table>
    </v-card-text>
  </v-card>
</template>

<script>
  import API from '@/api'
  const User = API.get('User')
  import moment from 'moment'

  export default {
    name: 'AssignCase',

    components: {
      DoctorsTable: () => import('./DoctorsTable.vue')
    },

    props: {
      info: {
        type: Object,
        default: function () {
          return { patient: null }
        }
      },
      showCloseBtn: {
        type: Boolean, 
        default: false 
      },
    },

    watch: {
      //
    },

    filters: {
      datetime: function (date) {
        return moment(date).format('MMM. D, YYYY, h:mmA');
      },
    },

    computed: {
      user() {
        var value = null
        if (typeof this.info == 'object') {
          if (Object.prototype.hasOwnProperty.call(this.info, 'patient')) {
            value = this.info.patient
          }
        }
        return value
      },
      patient() {
        var value = null
        if (this.user !== null) {
          if (typeof this.user == 'object') {
            if (Object.prototype.hasOwnProperty.call(this.user, 'patient')) {
              value = this.user.patient
            }
          }
        }
        return value
      },
      full_name() {
        var name = '';
        if (this.patient !== null) {
          if (Object.prototype.hasOwnProperty.call(this.patient, 'full_name')) {
            if (this.patient.full_name && this.patient.full_name !== null) {
              name = this.patient.full_name
            }
            else {
              if (this.patient.first_name || this.patient.last_name) {
                name = `${this.patient.first_name} ${this.patient.last_name}`;
              }
              else {
                name = this.user.email
              }
            }
          }
          else {
            name = this.user.email
          }
        }
        else {
          name = this.user.email
        }
        return name;
      },
      schedule() {
        var index = this.info.consultations.length - 1
        return this.$options.filters.datetime(this.info.consultations[index].call_datetime)
      }
    },

    data: () => ({
      doctors: []
    }),

    async mounted() {
      var testResponse = await User.getDoctors();
      var response = await User.getDoctors(testResponse.data.total);
      this.doctors = response.data.data.filter(doctor => doctor.doctor).map(doctor => {
        var doctor_info = doctor.doctor
        var specialization = 'N⁄A'
        if (typeof doctor_info.specialization == 'object')
          if (doctor_info.specialization !== null)
            if (doctor_info.specialization.specialization !== null)
              specialization = doctor_info.specialization.specialization.specialization
              
        return ({
          doctor: this.getFullName(doctor),
          specialization: specialization,
          status: 'online',
          availability: '10:00 - 12:00 NN',
          calls: [],
          full: doctor
        })
      })
    },

    methods: {
      consolelog(item) {
        console.log(item)
      },
      getFullName(item) {
        var name = '';
        var user = item.doctor
        if (user !== null) {
          if (Object.prototype.hasOwnProperty.call(user, 'fullname')) {
            name = user.fullname
          }
          else {
            if (user.first_name || user.last_name) {
              name = `${user.first_name} ${user.last_name}`;
            }
            else {
              name = user.email
            }
          }
        }
        return name;
      },
      getInfo() {
        console.log({ info: this.info })
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>